import { createFileRoute } from "@tanstack/react-router";
import dedent from "dedent";

import { FeedEmbed } from "@/components/FeedEmbed";

export const Route = createFileRoute("/feeds/embed/$feedId")({
  component: RouteComponent,
  ssr: false,
});

function RouteComponent() {
  const { feedId } = Route.useParams();

  return (
    <>
      <FeedEmbed feedId={feedId} />
      <style>
        {dedent`
            body {
                background-color: transparent !important;
            }
        `}
      </style>
    </>
  );
}
